module.exports = __webpack_public_path__ + "static/media/21ECLAC8.10b44ead.jpg";